{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Përmirëso",
    "navBilling": "Faturimi"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "Skeda jote. <em>Dhikri</em> yt.<br />I lartësuar.",
    "subtitle": "Çdo veçori që të nevojitet për një ditë më të qëllimshme — nga oraret e namazit dhe reflektimi i ajetit me AI te moti dhe detyrat me përparësi — në një skedë të re të qetë e të bukur.",
    "comparison_aria": "Krahasimi i planeve",
    "free": {
      "tierLabel": "Aktual",
      "tierName": "Free",
      "freeLabel": "Gjithmonë falas",
      "list_aria": "Veçoritë e planit Free"
    },
    "pro": {
      "list_aria": "Veçoritë e planit Pro",
      "tierLabel": "Përmirëso në",
      "tierName": "Pro",
      "pricePeriod": "/ muaj",
      "priceAlt": "ose $39.99 / vit"
    },
    "freeFeatures": {
      "clockDate": "Shfaqja e orës dhe datës",
      "verseOfDay": "Ajeti i ditës nga Kurani",
      "dailyBackground": "Foto e sfondit ditore",
      "qiblaCompass": "Busulla e Qiblas",
      "basicTasks": "Detyra bazë"
    },
    "proFeatures": {
      "weatherForecast": "Parashikimi i motit për 5 ditë",
      "verseFavorites": "Ruaj dhe shfleto ajetet e preferuara",
      "notesAi": "Shënime me analizë AI",
      "priorityTasks": "Menaxhimi i detyrave me përparësi",
      "verseReflection": "Reflektim mbi ajetin me AI"
    },
    "plans": {
      "monthly": {
        "label": "Mujor",
        "price": "$4.99",
        "period": "/ muaj",
        "note": "Faturuar mujore"
      },
      "yearly": {
        "label": "Vjetor",
        "price": "$39.99",
        "period": "/ vit",
        "note": "Dy muaj falas",
        "badge": "Kurse 33%"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "Anulo në çdo kohë. Qasja jote vazhdon deri në fund të periudhës së faturimit pa tarifa të pjesshme.",
    "billingPeriod_aria": "Periudha e faturimit",
    "cta": "Vazhdo te arka e sigurt",
    "ctaLoading": "Duke ridrejtuar te arka…",
    "promoManual": "Fut kodin {{code}} në faqen tjetër për të marrë zbritjen.",
    "signingUpAs": "Duke u regjistruar si {{account}}",
    "trustSignals_aria": "Sinjalet e besimit",
    "reassurance": {
      "secureCheckout": "Arkë e sigurt përmes Stripe",
      "cancelAnytime": "Anulo në çdo kohë, pa pyetje",
      "accessUntilEnd": "Qasje deri në fund të periudhës"
    },
    "errors": {
      "restoreSession": "Nuk mundëm të rikuperonim sesionin tënd. Të lutemi provo sërish nga zgjerimi.",
      "checkoutFailed": "Dështoi nisja e arkës. Të lutemi provo sërish."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Veçoritë e zhbllokuara",
    "unlockedFeatures": {
      "weatherForecast": "Parashikimi i motit për 5 ditë",
      "verseFavorites": "Ruaj dhe shfleto ajetet e preferuara",
      "notesAi": "Shënime me analizë AI",
      "priorityTasks": "Menaxhimi i detyrave me përparësi",
      "verseReflection": "Reflektim mbi ajetin me AI"
    },
    "success": {
      "title": "Mirë se erdhe te Pro",
      "desc": "Abonimi yt është aktiv. Kthehu te zgjerimi për të gjetur të gjitha veçoritë Pro që të presin.",
      "viewBilling": "Shiko detajet e faturimit",
      "closeTab": "Mbyll këtë skedë"
    },
    "cancel": {
      "title": "Arka u anulua",
      "desc": "Pa merak — plani yt nuk u ndryshua dhe nuk je faturuar. Mund të përmirësohesh kurdo që të jesh gati.",
      "backToUpgrade": "Kthehu te përmirësimi",
      "returnToExtension": "Kthehu te zgjerimi"
    }
  },
  "billing": {
    "title": "Faturimi",
    "subtitle": "Menaxho abonimin tënd dhe shiko historikun e pagesave.",
    "subscription_aria": "Statusi i abonimit",
    "subscriptionTitle": "Abonimi",
    "loading_aria": "Duke ngarkuar informacionin e faturimit",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Free",
    "statusLabels": {
      "active": "Aktiv",
      "trialing": "Provë falas",
      "past_due": "I vonuar",
      "unpaid": "I papaguar",
      "canceled": "I anuluar",
      "incomplete": "I paplotë",
      "none": "Pa abonim"
    },
    "planValues": {
      "proYearly": "Pro · Vjetor",
      "proMonthly": "Pro · Mujor"
    },
    "warnings": {
      "paymentFailedTitle": "Pagesa dështoi",
      "paymentFailedDesc": "Pagesa jote e fundit nuk kaloi. Përditëso mënyrën e pagesës përmes Menaxho Faturimin për të ruajtur qasjen Pro.",
      "trialEndingTitle": "Prova po përfundon së shpejti",
      "trialEndingToday": "Prova jote falas përfundon sot më {{date}}. Shto një mënyrë pagese për të ruajtur veçoritë e tua Pro.",
      "trialEndingInDays_one": "Prova jote falas përfundon për {{count}} ditë më {{date}}. Shto një mënyrë pagese për të ruajtur veçoritë e tua Pro.",
      "trialEndingInDays_other": "Prova jote falas përfundon për {{count}} ditë më {{date}}. Shto një mënyrë pagese për të ruajtur veçoritë e tua Pro."
    },
    "cancellationScheduled": "Anulimi u planifikua. E ruan qasjen e plotë Pro deri më <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "Prova përfundon sot",
      "trialDaysRemaining_one": "{{count}} ditë e mbetur në provë",
      "trialDaysRemaining_other": "{{count}} ditë të mbetura në provë",
      "renews": "Rinovohet më {{date}}",
      "accessUntil": "Qasje deri më {{date}}"
    },
    "kv": {
      "status": "Statusi",
      "nextRenewal": "Rinovimi tjetër",
      "trialEnds": "Prova përfundon",
      "trialDaysLeft_one": "{{count}} ditë e mbetur",
      "trialDaysLeft_other": "{{count}} ditë të mbetura",
      "endsToday": "përfundon sot",
      "plan": "Plani"
    },
    "upgradeNudge": {
      "title": "Zhblloko veçoritë Pro",
      "desc": "Moti, oraret e namazit, reflektimi i ajetit me AI dhe më shumë — $4.99/muaj ose $39.99/vit.",
      "cta": "Përmirëso"
    },
    "actions": {
      "manageBilling": "Menaxho faturimin dhe mënyrën e pagesës",
      "cancelConfirmTitle": "Të anulosh abonimin tënd?",
      "cancelConfirmDesc": "Do ta ruash qasjen e plotë Pro deri në fund të periudhës aktuale të faturimit. Nuk lëshohen rimbursime të pjesshme.",
      "canceling": "Duke anuluar…",
      "yesCancel": "Po, anulo",
      "keepPro": "Mbaj Pro",
      "cancelSubscription": "Anulo abonimin"
    },
    "noSubscription": "Nuk u gjet asnjë abonim.",
    "paymentHistory_aria": "Historiku i pagesave",
    "paymentHistoryTitle": "Historiku i pagesave",
    "invoices_aria": "Faturat",
    "invoiceView": "Shiko",
    "invoiceView_aria": "Shiko faturën nga {{date}}",
    "noInvoices": "Ende pa fatura.",
    "dangerZone_aria": "Zona e rrezikut",
    "dangerZoneTitle": "Zona e rrezikut",
    "deleteAccountTitle": "Fshij llogarinë",
    "deleteAccountDesc": "Fshij përgjithmonë llogarinë tënde dhe të gjitha të dhënat e lidhura — detyrat, shënimet, të preferuarat dhe historikun e faturimit. Ky veprim nuk mund të zhbëhet.",
    "deleteAccountBtn": "Fshij llogarinë",
    "deleteConfirm": {
      "warning": "Kjo do të bëjë menjëherë dhe përgjithmonë:",
      "list": {
        "deleteContent": "Të fshijë të gjitha detyrat, shënimet dhe ajetet e tua të preferuara",
        "cancelSubscription": "Të anulojë çdo abonim aktiv (pa rimbursim për kohën e papërdorur)",
        "removeAccount": "Të heqë llogarinë tënde nga baza jonë e të dhënave",
        "signOut": "Të çkyçë nga të gjitha pajisjet"
      },
      "typeToConfirm": "Shkruaj <strong>DELETE</strong> për të konfirmuar",
      "inputPlaceholder": "DELETE",
      "deleting": "Duke fshirë…",
      "confirmBtn": "Fshij përgjithmonë llogarinë time",
      "cancelBtn": "Anulo"
    },
    "errors": {
      "loadFailed": "Dështoi ngarkimi i informacionit të faturimit.",
      "cancelFailed": "Dështoi anulimi i abonimit.",
      "deleteFailed": "Dështoi fshirja e llogarisë. Të lutemi provo sërish ose kontakto mbështetjen.",
      "portalFailed": "Dështoi hapja e portalit të faturimit."
    }
  },
  "privacy": {
    "tocLabel": "Politika e Privatësisë",
    "toc_aria": "Tabela e përmbajtjes",
    "lastUpdated": "Përditësuar së fundi<br />22 shtator 2026",
    "sections": {
      "overview": "Përmbledhje",
      "informationWeCollect": "Informacioni që Mbledhim",
      "connectedServices": "Shërbimet e Lidhura (Google, Todoist, Apple)",
      "howWeUse": "Si e Përdorim Informacionin Tënd",
      "howWeShare": "Si e Ndajmë Informacionin Tënd",
      "dataRetention": "Ruajtja e të Dhënave",
      "yourRights": "Të Drejtat e Tua të Privatësisë",
      "california": "Banorët e Kalifornisë (CCPA/CPRA)",
      "cookies": "Cookies dhe Ruajtja Lokale",
      "security": "Siguria e të Dhënave",
      "changes": "Ndryshimet e Kësaj Politike",
      "contact": "Na Kontakto"
    },
    "headings": {
      "informationWeCollect": "Informacioni që Mbledhim",
      "connectedServices": "Shërbimet e Lidhura (Google, Todoist, Apple)",
      "howWeUse": "Si e Përdorim Informacionin Tënd",
      "howWeShare": "Si e Ndajmë Informacionin Tënd",
      "dataRetention": "Ruajtja e të Dhënave",
      "yourRights": "Të Drejtat e Tua të Privatësisë",
      "california": "Banorët e Kalifornisë (CCPA / CPRA)",
      "cookies": "Cookies dhe Ruajtja Lokale",
      "security": "Siguria e të Dhënave",
      "changes": "Ndryshimet e Kësaj Politike",
      "contact": "Na Kontakto"
    }
  },
  "deleteAccount": {
    "intro": "Fshirja e llogarisë heq përgjithmonë:",
    "list": {
      "account": "Llogarinë dhe profilin tënd",
      "tasks": "Të gjitha detyrat",
      "notes": "Të gjitha shënimet",
      "verses": "Vargjet e ruajtura",
      "billing": "Të dhënat e abonimit"
    },
    "irreversible": "Ky veprim nuk mund të zhbëhet.",
    "appleNotice": "Fshirja e llogarisë nuk e anulon një abonim të blerë përmes App Store. Të lutem anuloje edhe te Cilësimet → Apple ID → Abonimet.",
    "manageSubscription": "Menaxho abonimin",
    "continueBtn": "Vazhdo me fshirjen",
    "keepBtn": "Mbaj llogarinë time",
    "confirmTitle": "Të fshihet llogaria jote?",
    "confirmDesc": "Llogaria jote dhe të gjitha të dhënat e saj do të fshihen përgjithmonë. Ky veprim nuk mund të zhbëhet.",
    "confirmBtn": "Fshij përgjithmonë llogarinë time",
    "deleting": "Duke fshirë…",
    "error": "Nuk mundëm ta fshijmë llogarinë tënde. Kontrollo lidhjen dhe provo sërish."
  }
}
